import {
  ENTER_PASSWORD,
  TOGGLE_PROCESS_MODAL,
  TOGGLE_ADMIN_MODAL,
  SUBMISSIONS_LOADING,
  GET_SUBMISSIONS,
  GET_COMMENTS,
  DELETE_COMMENT,
  GET_VISITORS
} from "../actions/types";

const initialState = {
  processModalIsOpen: false,
  password: null,
  approvalModalIsOpen: false,
  submissionsLoading: false,
  processSubmissions: [],
  referenceSubmissions: [],
  comments: [],
  visitors: 0
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ENTER_PASSWORD:
      return {
        ...state,
        password: action.payload
      };
    case TOGGLE_ADMIN_MODAL: {
      return {
        ...state,
        approvalModalIsOpen: !state.approvalModalIsOpen
      };
    }
    case TOGGLE_PROCESS_MODAL: {
      return {
        ...state,
        processModalIsOpen: !state.processModalIsOpen
      };
    }
    case SUBMISSIONS_LOADING: {
      return {
        ...state,
        submissionsLoading: true
      };
    }
    case GET_SUBMISSIONS: {
      const processSubmissions = action.payload.processSubmissions.map(
        submission => ({
          id: submission.process_id,
          material: submission.process_material,
          reactants: [
            submission.process_reactantA,
            submission.process_reactantB,
            submission.process_reactantC,
            submission.process_reactantD
          ],
          reference: {
            doi: submission.reference_doi,
            id: submission.reference_id
          }
        })
      );
      const referenceSubmissions = action.payload.referenceSubmissions.map(
        submission => ({
          id: submission.process_id,
          material: submission.process_material,
          reactants: [
            submission.process_reactantA,
            submission.process_reactantB,
            submission.process_reactantC,
            submission.process_reactantD
          ],
          reference: {
            doi: submission.reference_doi,
            id: submission.reference_id
          }
        })
      );

      return {
        ...state,
        submissionsLoading: false,
        processSubmissions,
        referenceSubmissions
      };
    }
    case GET_COMMENTS:
      return { ...state, comments: action.payload };
    case DELETE_COMMENT: {
      const deletedId = action.payload;

      const newComments = state.comments.filter(
        comment => comment.comment_id !== deletedId
      );

      return { ...state, comments: newComments };
    }
    case GET_VISITORS: {
      return { ...state, visitors: action.payload };
    }
    default:
      return state;
  }
}
